import * as React from 'react';
import Dropzone from 'react-dropzone';
import { Button, Card, Row } from '@nackle/paper';
import { CloudUpload } from '@nackle/icons/dist/react-es/ultimate';
// styles
import './pdf-upload.less';

export default class PDFUpload extends React.Component {
    state = {
        file: { name: '', preview: '' },
        loading: false
    };
    componentDidUpdate( prevProps ) {
        if ( !!prevProps.PDFFile && !this.props.PDFFile ) {
            this.setState( { file: { name: '', preview: '' } } );
        }
    }
    onDrop = async files => {
        const reader = new FileReader();
        this.setState( { loading: true } );
        await reader.addEventListener( 'loadend', () => this.props.handlePDFFile( files ), false );
        reader.readAsArrayBuffer( files[ 0 ] );
        this.setState( { file: files[ 0 ], loading: false } );
    };
    render() {
        const { loading } = this.state;
        return (
            <div>
                <Dropzone
                    multiple={ true }
                    onDrop={ this.onDrop }
                    onFileDialogCancel={ this.props.onCancel }
                    accept="application/pdf"
                    disabled={ this.props.disabled }
                >
                    { ( { getRootProps, getInputProps } ) => (
                        <Row>
                            <Card { ...getRootProps() } style={ { backgroundColor: '#80808038' } }>
                                <input { ...getInputProps() } />
                                <Button disabled={ this.props.disabled } icon={ <CloudUpload /> }>
                                    Drop files here, or click to select files
                                </Button>
                            </Card>
                        </Row>
                    ) }
                </Dropzone>
                { loading && <span>Loading...</span> }
            </div>
        );
    }
}
